/* eslint-disable max-len */

import CBAM_SECTION1 from '../../../../../assets/cbamSection1.png';
import CBAM_SECTION2 from '../../../../../assets/cbamSection2.png';
import CBAM_SECTION3 from '../../../../../assets/cbamSection3.png';
import CBAM_SECTION4 from '../../../../../assets/cbamSection4.png';
import CBAM_SECTION5 from '../../../../../assets/cbamSection5.png';
import CBAM_SECTION6 from '../../../../../assets/cbamSection6.png';
import CBAM_SECTION7 from '../../../../../assets/cbamSection7.png';
import {getCbamIronAndSteelUrl} from '../utils/utils';

import {
  section1PlantAndProductionInformationTabQuestions,
  section2SourceStreamAndDirectEmissionsDataTabQuestions,
  section3ElectricityAndIndirectEmissionsTabQuestions,
  section4ProcessLevelProductionAndEmissionsDataTabQuestions,
  section5PrecursorPurchasedInputEmissionsDataTabQuestions,
  section6CarbonPricingAndTaxAdjustmentTabQuestions,
  section7ShipmentAndCustomsInformationTabQuestions
} from './ironandSteelTabs';

export const pillers = {
  ironAndSteelPlantAndProductionInformation:
    'section1Plant&ProductionInformation',
  ironAndSteelSourceStreamAndDirectEmissionsData:
    'section2SourceStream&DirectEmissionsData',
  ironAndSteelElectricityAndIndirectEmissions:
    'section3Electricity&IndirectEmissions',
  ironAndSteelProcessLevelProductionAndEmissionsData:
    'section4ProcessLevelProduction&EmissionsData',
  ironAndSteelPrecursorPurchasedInputEmissionsData:
    'section5PrecursorPurchasedInputEmissionsData',
  ironAndSteelCarbonPricingAndTaxAdjustment:
    'section6CarbonPricing&TaxAdjustment',
  ironAndSteelShipmentAndCustomsInformation:
    'section7Shipment&CustomsInformation'
};

export const cbamSection1IronAndSteelPlantAndProductionInformationQuestions = {
  header: {
    imageUrl: CBAM_SECTION1,
    title: 'SECTION 1 – PLANT & PRODUCTION INFORMATION',
    description:
      'Captures plant-level identification, location, ownership, and operational details. Establishes clarity on production capacity, operational status, and scope of manufacturing activities carried out at the facility.',
    noOfModules: 4,
    answeredQuestions: 0,
    totalQuestions: 14
  },
  APIRoute: getCbamIronAndSteelUrl(
    pillers.ironAndSteelPlantAndProductionInformation
  ),
  tabs: [
    {
      id: 'plantAndProductionInformation',
      title: 'Section 1 – Plant & Production Information',
      questions: section1PlantAndProductionInformationTabQuestions
    }
  ]
};

export const cbamSection2IronAndSteelSourceStreamAndDirectEmissionsDataQuestions =
  {
    header: {
      imageUrl: CBAM_SECTION2,
      title: 'SECTION 2 – SOURCE STREAM & DIRECT EMISSIONS DATA',
      description: `Captures fuel/material source identification, emission calculation methodology, 
      activity data, emission factors, biomass treatment, and carbon quality parameters. Establishes the 
      quantitative basis for calculating CO₂ emissions under CBAM methodology.`,
      noOfModules: 4,
      answeredQuestions: 0,
      totalQuestions: 14
    },
    APIRoute: getCbamIronAndSteelUrl(
      pillers.ironAndSteelSourceStreamAndDirectEmissionsData
    ),
    tabs: [
      {
        id: 'sourceStreamAndDirectEmissionsData',
        title: 'Section 2 – Source Stream & Direct Emissions Data',
        questions: section2SourceStreamAndDirectEmissionsDataTabQuestions
      }
    ]
  };

export const cbamSection3IronAndSteelElectricityAndIndirectEmissionsQuestions =
  {
    header: {
      imageUrl: CBAM_SECTION3,
      title: 'SECTION 3 – ELECTRICITY & INDIRECT EMISSIONS',
      description: `Captures fuel allocation, monitoring approach, electricity sourcing, emission factor selection, and CHP efficiency parameters.
       Establishes the framework for calculating indirect (Scope 2) emissions and properly allocating fuel use between electricity generation, non-CBAM activities, and exported power.`,
      noOfModules: 4,
      answeredQuestions: 0,
      totalQuestions: 14
    },
    APIRoute: getCbamIronAndSteelUrl(
      pillers.ironAndSteelElectricityAndIndirectEmissions
    ),
    tabs: [
      {
        id: 'electricityAndIndirectEmissions',
        title: 'Section 3 – Electricity & Indirect Emissions',
        questions: section3ElectricityAndIndirectEmissionsTabQuestions
      }
    ]
  };

export const cbamSection4IronAndSteelProcessLevelProductionAndEmissionsDataQuestions =
  {
    header: {
      imageUrl: CBAM_SECTION4,
      title: 'SECTION 4 – PROCESS-LEVEL PRODUCTION & EMISSIONS DATA',
      description: `Captures process-level identification, product classification, production volumes, fuel attribution, energy balance, waste gas management, 
      scrap usage, electricity consumption, and carbon capture. Establishes the detailed operational boundaries and embedded emissions calculation at the individual production unit level under CBAM methodology.`,
      noOfModules: 4,
      answeredQuestions: 0,
      totalQuestions: 14
    },
    APIRoute: getCbamIronAndSteelUrl(
      pillers.ironAndSteelProcessLevelProductionAndEmissionsData
    ),
    tabs: [
      {
        id: 'processLevelProductionAndEmissionsData',
        title: 'Section 4 – Process-Level Production & Emissions Data',
        questions: section4ProcessLevelProductionAndEmissionsDataTabQuestions
      }
    ]
  };

export const cbamSection5IronAndSteelPrecursorPurchasedInputEmissionsDataQuestions =
  {
    header: {
      imageUrl: CBAM_SECTION5,
      title: 'SECTION 5 – PRECURSOR (PURCHASED INPUT) EMISSIONS DATA',
      description: `Captures identification, origin, embedded emissions, data source, and process linkage of purchased CBAM precursors.
       Establishes the calculation of embedded emissions from imported semi-finished materials and ensures correct attribution to production processes under CBAM rules.`,
      noOfModules: 4,
      answeredQuestions: 0,
      totalQuestions: 14
    },
    APIRoute: getCbamIronAndSteelUrl(
      pillers.ironAndSteelPrecursorPurchasedInputEmissionsData
    ),
    tabs: [
      {
        id: 'precursorPurchasedInputEmissionsData',
        title: 'Section 5 – Precursor Purchased Input Emissions Data',
        questions: section5PrecursorPurchasedInputEmissionsDataTabQuestions
      }
    ]
  };

export const cbamSection6IronAndSteelCarbonPricingAndTaxAdjustmentQuestions = {
  header: {
    imageUrl: CBAM_SECTION6,
    title: 'SECTION 6 – CARBON PRICING & TAX ADJUSTMENT',
    description: `Captures information on carbon price paid in the country of origin, including legal basis, payment details, emissions coverage, and 
    supporting documentation. Establishes eligibility for CBAM carbon price deductions and ensures proper financial adjustment against EU CBAM obligations.`,
    noOfModules: 4,
    answeredQuestions: 0,
    totalQuestions: 14
  },
  APIRoute: getCbamIronAndSteelUrl(
    pillers.ironAndSteelCarbonPricingAndTaxAdjustment
  ),
  tabs: [
    {
      id: 'carbonPricingAndTaxAdjustment',
      title: 'Section 6 – Carbon Pricing & Tax Adjustment',
      questions: section6CarbonPricingAndTaxAdjustmentTabQuestions
    }
  ]
};

export const cbamSection7IronAndSteelShipmentAndCustomsInformationQuestions = {
  header: {
    imageUrl: CBAM_SECTION7,
    title: 'SECTION 7 – SHIPMENT & CUSTOMS INFORMATION',
    description: `Captures shipment-level identification, invoice linkage, and logistics details required for customs traceability. 
    Establishes the connection between CBAM declarations, commercial documentation, and physical movement of goods into the EU.`,
    noOfModules: 4,
    answeredQuestions: 0,
    totalQuestions: 14
  },
  APIRoute: getCbamIronAndSteelUrl(
    pillers.ironAndSteelShipmentAndCustomsInformation
  ),
  tabs: [
    {
      id: 'shipmentIdentification',
      title: 'Section 7 – Shipment & Customs Information',
      questions: section7ShipmentAndCustomsInformationTabQuestions
    }
  ]
};
